export default "__VITE_ASSET__BsVR9ilG__"